import { cdnUrl } from '@/constants';
import i18n from '@/localisation/i18n';
import useAppStore from '@/store/app';
import { useUserStore } from '@/store/user';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Link } from 'react-router-dom';

export const ProfilePreview = () => {
  const { img, name } = useUserStore();
  const { closeDrawer } = useAppStore();

  return (
    <Link
      to="/profile"
      className="mt-5 flex items-center justify-between md:mt-10"
      onClick={closeDrawer}
    >
      <div className="flex items-start">
        {img ? (
          <div className="avatar relative">
            <div className="absolute top-0.5 right-0.5 !flex h-3 w-3 items-center justify-center rounded-full bg-white">
              <div className="bg-success h-2 w-2 rounded-full" />
            </div>
            <div className="w-12 rounded-full">
              <LazyLoadImage
                width={48}
                height={48}
                effect="opacity"
                src={`${cdnUrl}/psychologists/${img}`}
                alt="Selected"
              />
            </div>
          </div>
        ) : (
          <div className="avatar placeholder">
            <div className="flex! w-12 items-center justify-center rounded-full bg-[#DAD4F6]">
              <img className="!h-6 !w-6" src="/icons/user.svg" alt="psycho" />
            </div>
          </div>
        )}
        <div className="ml-3">
          <div className="text-base font-bold">
            {name ? name : i18n.t('anonymous')}
          </div>
          <div className="text-xs">{i18n.t('psychologist')}</div>
        </div>
      </div>
      {(!img || !name) && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="mt-0.5 h-6 w-6 shrink-0 stroke-[var(--orange)]"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
      )}
    </Link>
  );
};
